import { useEffect, useState } from 'react';
import axios from 'axios';
import { Skill } from '../models/SkillsInterfaces';

export const useGetSkillsByCategory = (cetegoryOutsidePopup = '') => {
  const [skillsByCategory, setSkillsByCategory] = useState<Skill[]>([]);
  const [selectedCategory, setSelectedCategory] =
    useState<string>(cetegoryOutsidePopup);

  const handleCategoryChange = (category: string) => {
    setSelectedCategory(category);
  };

  const getSkillsByCattegory = async () => {
    try {
      const response = await axios.get(
        `api/skills?category[]=${selectedCategory}`
      );
      setSkillsByCategory(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getSkillsByCattegory();
  }, [selectedCategory]);

  return { skillsByCategory, handleCategoryChange };
};
